export default __webpack_public_path__ + "static/media/backgroundMobile.433ef1c1.png";